import MojitoCore from 'mojito/core';

const log = MojitoCore.logger.get('SharingServiceFactory');

const voidResponder = () => {
    log.warn('sharingService instance is missing.');
    return Promise.reject();
};

const NULL_SERVICE = {
    copyTextToClipboard: voidResponder,
    webShare: voidResponder,
    shareImage: voidResponder,
};

/**
 * Config object used to initialise sharing service layer.
 *
 * @typedef SharingServiceConfig
 * @type {object}
 * @property {Mojito.Services.Sharing.AbstractSharingService} service - Sharing service implementation.
 *
 * @memberof Mojito.Services.Sharing
 */

/**
 * Singleton object that receives sharing config and spawn service instance.
 *
 * @class ServiceFactory
 * @name serviceFactory
 * @memberof Mojito.Services.Sharing
 */
class ServiceFactory {
    constructor() {
        this.service = NULL_SERVICE;
    }

    /**
     * Init factory.
     *
     * @function init
     *
     * @param {Mojito.Services.Sharing.SharingServiceConfig} config - Sharing config.
     *
     * @memberof Mojito.Services.Sharing.serviceFactory
     */
    init({ service }) {
        this.service = service;
    }

    /**
     * Service getter.
     *
     * @function getService
     *
     * @returns {Mojito.Services.Sharing.AbstractSharingService} Sharing service instance.
     *
     * @memberof Mojito.Services.Sharing.serviceFactory
     */
    getService() {
        return this.service;
    }
}

export default new ServiceFactory();
